module.exports = __webpack_public_path__ + "static/img/info-img-2-281x300.b1f455e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/info-img-2-281x300.png
// module id = /wDV
// module chunks = 0